export default object => ({
  id: object.id,
  protocolNumber: object.protocolNumber,
  name: object.name,
  telephone: object.telephone,
});
